import Clickable from 'components/Common/Clickable'
import BodyText from 'LuxKit/Typography/BodyText'
import Image from 'components/Common/Image/Image'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'
import type { CityTrendingDestination } from './TripLandingPageTrendingDestinations'
import qs from 'qs'
import { CHAT_TRIP_PLANNER_NEW_PATH } from 'tripPlanner/config'

const Section = styled(Clickable)`
  display: grid;
  gap: ${rem(16)};
  grid-template-columns: ${rem(85)} 1fr;
  width: ${rem(280)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr;
    grid-template-rows: ${rem(180)} 1fr;
    flex-direction: column;
    grid-gap: ${rem(12)};
    width: ${rem(180)};
  }
`

interface Props {
  trendingDestination: CityTrendingDestination
}

function TrendingDestinationsTile(props: Props) {
  const { trendingDestination } = props
  const intl = useIntl()

  const query = qs.stringify({ location: trendingDestination.name })
  const generateTripUrl = `${CHAT_TRIP_PLANNER_NEW_PATH}?${query}`
  const countryLabel = trendingDestination.countryCode
    ? intl.formatDisplayName(trendingDestination.countryCode, { type: 'region' }) ?? trendingDestination.countryCode
    : undefined
  const destinationLabel = trendingDestination.displayName ?? trendingDestination.name
  return (
    <Section to={generateTripUrl}>
      <Image
        fit="center"
        width={180}
        height={180}
        dpr={2}
        aspectRatio="1:1"
        id={trendingDestination.imageId}
      />
      <Group direction="vertical" gap={4} horizontalAlign="start" verticalAlign="center" tabletVerticalAlign="start">
        <BodyText variant="large" weight="bold">{destinationLabel}</BodyText>
        {!!countryLabel && <BodyText variant="small">{countryLabel}</BodyText>}
      </Group>
    </Section>
  )
}

export default TrendingDestinationsTile
